import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/navbar2.js';
import { BrowserRouter as Router, Routes, Route }
	from 'react-router-dom';
import Home from './pages';
import Home2 from './pages/index2';
import Portfolio from './pages/portfolio';
import Portfolio2 from './pages/portfolio2';
import Services1 from './pages/services1';
import SEO from './pages/seo';
import AppDev from './pages/app';
import FullStack from './pages/fullstack';
import Project1 from './pages/project1';
import Project2 from './pages/project2';
import Project3 from './pages/project3';
import Project4 from './pages/project4';
import Security from './pages/security';
import Webdev from './pages/webdev';
import Contact from './pages/contact';
import Contact2 from './pages/contact2';
import ContactPage from './pages/ContactPage';
import Appdev from './pages/appdev';
import About from './pages/about';
import Pricing from './pages/pricing';
import Social_Media_Marketing from './pages/social_media_marketing';
import Blog from './pages/blog';
import BlogArticle from './pages/BlogPost.js';
import GetStarted from "./pages/get-started";
import StartNoWebsite from "./pages/start-no-website";
import FixMyWebsite from "./pages/fix-my-website";
import GetMoreCustomers from "./pages/get-more-customers";
import { ChatPanel } from "./widget/components/ChatPanel";
import smoothscroll from 'smoothscroll-polyfill';

function App() {
  smoothscroll.polyfill();

  const [isVisible, setIsVisible] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  

  const handleScroll = () => {
    const scrollTop = window.pageYOffset;
    if (scrollTop > 300) { // Adjust this value as per your requirement
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  /*useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);*/

  useEffect(() => {
  const updateToTopPosition = () => {
    const btn = document.querySelector('.to-top-btn');
    if (!btn) return;

    if (window.innerWidth <= 1180) {
      btn.style.right = '20px';
    } else {
      btn.style.right = '60px';
    }
  };

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', updateToTopPosition);

  updateToTopPosition();

  return () => {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('resize', updateToTopPosition);
  };
}, [isVisible]);

const updateChatButtonPosition = () => {
  const btn = document.querySelector('.chat-launch-btn');
  if (!btn) return;

  if (window.innerWidth <= 1180) {
    btn.style.left = '20px';
  } else {
    btn.style.left = '60px';
  }
};
window.addEventListener('resize', updateChatButtonPosition);
updateChatButtonPosition();

	return (
		<Router>
			<Navbar />
			<Routes>
				<Route exact path='/index' element={<Home />} />
        <Route exact path='/' element={<Home2 />} />
				<Route path='/portfolio' element={<Portfolio />} />
        <Route path='/portfolio2' element={<Portfolio2 />} />
        <Route path='/services1' element={<Services1 />} />
        <Route path='/seo' element={<SEO />} />
        <Route path='/app' element={<AppDev />} />
        <Route path='/fullstack' element={<FullStack />} />
        <Route path='/project1' element={<Project1 />} />
        <Route path='/project2' element={<Project2 />} />
        <Route path='/project3' element={<Project3 />} />
        <Route path='/project4' element={<Project4 />} />
        <Route path='/security' element={<Security />} />
				<Route path='/contact' element={<Contact />} />
        <Route path='/contact2' element={<Contact2 />} />
        <Route path='/ContactPage' element={<ContactPage />} />
				<Route path='/webdev' element={<Webdev />} />
        <Route path='/appdev' element={<Appdev />} />
        <Route path='/about' element={<About />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/social_media_marketing' element={<Social_Media_Marketing />} />
        <Route path='/blog' element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogArticle />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/start-no-website" element={<StartNoWebsite />} />
        <Route path="/fix-my-website" element={<FixMyWebsite />} />
        <Route path="/get-more-customers" element={<GetMoreCustomers />} />
        
			</Routes>
      {chatOpen && (
        <div
              style={{
              position: 'fixed',
              right: '20px',
              bottom: '100px',
              width: 'min(380px, calc(100vw - 40px))',
              height: 'min(600px, calc(100vh - 140px))',
              zIndex: 2147483646,
              background: '#fff',
              border: '1px solid rgba(0,0,0,0.10)',
              borderRadius: '16px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
              overflow: 'hidden'
            }}
        >
        <ChatPanel
              tenant={{
              tenantId: "local",
              name: "Yokai Software",
              config: {
                  serviceArea: ["Florida", "Remote"]
                }
              }}
              primary="#7209b7"
        />
        </div>
      )}

      {isVisible && (
        <button className="to-top-btn" onClick={scrollToTop}>
          Top 
        </button>
      )}
<button
  onClick={() => setChatOpen((prev) => !prev)}
  className="chat-launch-btn"
  style={{
    position: 'fixed',
    left: '60px',
    bottom: '20px',
    zIndex: 2147483647,
    border: 'none',
    background: 'rgb(200, 25, 215)',
    color: '#fff',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    fontSize: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 6px 18px rgba(0,0,0,0.2)',
    cursor: 'pointer'
  }}
  aria-label="Open chat"
>
  {chatOpen ? '✕' : '💬'}
</button>
		</Router>
	);
}

export default App;



//import logo from './logo.svg';
//import './App.css';

//function App() {
  //return (
    //<div className="App">
      //<header className="App-header">
        //<img src={logo} className="App-logo" alt="logo" />
        //<p>
          //Edit <code>src/App.js</code> and save to reload.
       // </p>
        //<a
         // className="App-link"
          //href="https://reactjs.org"
          //target="_blank"
          //rel="noopener noreferrer"
        //>
          //Learn React
        //</a>
      //</header>
    //</div>
  //);
//}

//export default App;
